<script setup>
import { defineProps } from "vue"
import { Gems } from "@/gems"
import RatingScale from "../RatingScale.vue"
import BaseSelect from "../BaseSelect.vue";
import { useValidationListView } from '@/composables/useValidationListView'
import TransferRowsMobile from "./TransferRowsMobile.vue";

const props = defineProps({
  validateData: {
    type: Object,
    default: Object
  },

  ratingData: {
    type: Object,
    default: Object
  },
  
  validationWithCertification: {
    type: Boolean,
    default: false
  },

  ratingSkillsModal: {
    type: Object,
    default: Object
  },
})

const {
  userStore,
  ratingType,
  userFilter,
  requestDateAsc,
  VALIDATION_LABEL,
  formatDate,
  getHistory,
  canPostValidation,
  openHistoryItemModal,
  validateHistoryItem
} = useValidationListView({
  validateData: props.validateData,
  ratingSkillsModal: props.ratingSkillsModal
})

</script>

<template>
  <div class="div-validate-list">
    <div class="div-admin-filter-input">
      <input class="ddl-alt-padding w-100 input-small-padding" type="text" v-model="userFilter" placeholder="Procurar..." />
    </div>

    <div class="div-admin-filter pt-2">
      <div class="div-radios" v-if="!props.validateData.validationToTransfer.value">
        <div>
          <input class="cursor-pointer" type="radio" value="2" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Em aberto</label>
        </div>
        
        <div>
          <input class="cursor-pointer" type="radio" value="1" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Publicados</label>
        </div>
        
        <div>
          <input class="cursor-pointer" type="radio" value="3" v-model="ratingType" @change="props.validateData.RequestValidationList()"/>
          <label for="">Todos</label>
        </div>
      </div>

      <div class="cursor-pointer div-admin-sort" @click="props.validateData.ToggleRequestDateSort(requestDateAsc = !requestDateAsc)" >
        <i class="fs-5 bi" :class="{'bi-sort-numeric-up': !requestDateAsc ,'bi-sort-numeric-down': requestDateAsc}" />
        <label class="cursor-pointer">Ordenar por data do pedido</label>
      </div>
    </div>

    <div v-if="props.validateData.filteredValidationList.value.length == 0 && !props.validateData.showUserRequests.value" class="div-empty-list">
      <span v-if="props.validateData.validationToTransfer.value"> Sem pedidos de transferência </span>
      <span v-else>Sem resultados [{{ratingType == 1 ? 'Publicados' : ratingType == ratingType == 2 ? 'Em aberto' : 'Todos'}}]</span>
    </div>

    <div v-else-if="props.validateData.validationList.value.length > 0 && !props.validateData.showUserRequests.value">

      <div class="list-teams list-header row p-0 pt-3 w-100">
        <span class="col-4 text-start">Equipa(s)</span>
        <span class="col-2 p-0 text-center line-clamp line-clamp-1">Nº Utilizadores</span>
        <span class="col-2 p-0 text-center line-clamp line-clamp-1">{{ratingType == 1 ? 'Publicados' : ratingType == 2 ? 'Em aberto' : 'Todos'}}</span>
        <span class="col-2 p-0 text-center line-clamp line-clamp-1">Novas Mensagens</span>
        <span class="col-2 p-0 text-center line-clamp line-clamp-1" @click="props.validateData.ToggleAllTeams()">{{props.validateData.toggleAllTeams.value ? 'Fechar' : 'Expandir'}} todos</span>
      </div>

      <div class="list-item" :class="{'bg-alt-line': i % 2 == 0, 'div-history-frame': team.showDetail}" v-for="(team, i) in props.validateData.filteredValidationList.value" :key="team.id">
        <div class="list-teams row">
          <span class="col-4 text-start">{{ team.designation }}</span>

          <span class="col-2 text-center">{{ ratingType != 3 ? team[`rating_${ratingType}_user_count`] : team[`rating_1_user_count`] + team[`rating_2_user_count`] }}</span>
        
          <span class="col-2 text-center">{{ ratingType != 3 ? team[`rating_${ratingType}_count`] : team[`rating_1_count`] + team[`rating_2_count`] }}</span>

          <span class="col-2 p-0 text-center">
            <i v-if="team[`new_messages_count_${ratingType}`] > 0" class="fas icon-size fa-envelope"></i>
          </span>

          <i class="col-2 bi bi-chevron-down text-end cursor-pointer" :class="{'bi-chevron-up': team.showDetail}" @click="team.showDetail = !team.showDetail"></i>
        </div>

        <div v-show="team.showDetail">
          <div v-for="(user, ui) in team.users" :key="ui" v-show="!user.hide">
            <div class="list-users row">

              <span class="col-4 text-start">{{ user.name }}</span>
            
              <span class="col-2"></span>

              <span class="col-2 text-center">{{ ratingType != 3 ? user[`rating_${ratingType}_count`] : user[`rating_1_count`] + user[`rating_2_count`] }}</span>

              <span class="col-2 p-0 text-center">
                <i v-if="user[`new_messages_count_${ratingType}`] > 0" class="fas icon-size fa-envelope"></i>
              </span>

              <i class="col-2 bi bi-arrow-return-right text-end cursor-pointer" @click="props.validateData.ShowUserRequests(user)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="props.validateData.validationList.value.length >= 0 && props.validateData.showUserRequests.value">
      <div v-if="(props.validateData.displayedRequests.value || []).length === 0">
        <div class="div-user-sitemap">
          <span @click="props.validateData.BackToTeams()" class="fw-bold cursor-pointer">Equipas</span>
          <i class="bi bi-arrow-right"></i>
          <span>{{ props.validateData.userSelected.value.team_designation }}</span>
          <i class="bi bi-arrow-right"></i>
          <span>{{ props.validateData.userSelected.value.name }}</span>
        </div>

        <div class="div-empty-list">
          <span> Sem {{ props.validateData.validationToTransfer.value ? 'pedidos de transferência' : 'validações'}} para o utilizador selecionado</span>
        </div>
      </div>

      <div v-else-if="props.validateData.validationToTransfer.value">
        <TransferRowsMobile :validate-data="props.validateData" :validation-list="props.validateData.displayedRequests.value" :rating-data="props.ratingData" :rating-skills-modal="props.ratingSkillsModal"/>
      </div>

      <div v-else>
        <div class="list-item row fw-bold p-1 m-0">
          <span class="col-4 p-0" :class="{'col-4': props.validateData.isLowerThanMobile.value}">Descrição</span>
          <span class="col-6 p-0" :class="{'col-6': props.validateData.isLowerThanMobile.value}">Classificação</span>
          <span></span>
        </div>

        <div class="list-item" :class="{'bg-alt-line': i % 2 == 0, 'div-to-validate': elem.validation_date == null && ratingType == 3, 'div-history-frame': elem.showOtherValidators}"
          v-for="(elem, i) in props.validateData.displayedRequests.value" :key="i">
          <div class="row align-items-center p-1 m-0">

            <span class="col-5 p-0 line-clamp line-clamp-1" :class="{'col-6': props.validateData.isLowerThanMobile.value}" @mouseenter="Gems.TooltipIfNeeded($event.target)">
              <span class="align-content-center">
                <i class="fas fa-chevron-down cursor-pointer me-1" @click="getHistory(elem)" v-if="elem.has_more && (elem.rating_type == 2 && userStore.User?.permissions?.is_admin)"></i>
                <div class="div-without-history" v-else></div>
              </span>

              <i v-if="!elem.is_op_skill" class="fa-solid fa-copyright me-1" @mouseover="Gems.Tooltip($event.target, 'Conhecimento', 'tooltip')"></i>
              <span @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
                {{ elem.designation }}
              </span>
            </span>
          
            <span class="col-5 p-0 radios">
              <RatingScale :rating-data="props.ratingData" :element="elem" :mobile-view="true" :validate-skills="true"/>
            </span>

            <div class="col-2 p-0 ps-1 d-flex">
              <div class="d-flex justify-content-center flex-grow-1">
                <i class="align-content-center far fa-eye" :class="{'eye-notification': elem.has_files_not_viewed }" 
                  @click="props.ratingSkillsModal.OpenModalDocs(elem)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')"></i>
                <i class="align-content-center fas fa-envelope" v-if="elem.has_unread_messages_only_validators || elem.has_unread_messages" 
                  @mouseenter="Gems.Tooltip($event.target, 'Tens novas mensagens', 'tooltip')"></i>
              </div>
              <i class="bi bi-chevron-down col-auto p-0 ps-1 align-content-center text-end" :class="{'bi-chevron-up': elem.showDetail}" @click="elem.showDetail = !elem.showDetail"></i>
            </div>
          </div>
          
          <div class="row element-detail p-1 m-0 small" v-show="elem.showDetail">
            <div class="col-4 p-0">
              <div class="text-uppercase">{{ props.validateData.validationToTransfer.value ? 'Validador atual' : 'Validação' }}</div>
              <div class="line-clamp line-clamp-1" @mouseenter="Gems.TooltipIfNeeded($event.target)">{{ elem.validator_name }}</div>
            </div>

            <div class="col-4 p-0">
              <div class="text-uppercase">{{ props.validateData.validationToTransfer.value ? 'Validador novo' : 'Decisão' }}</div>
              <base-select class="ddl-alt-padding" v-if="props.validateData.validationToTransfer.value" v-model="elem.newValidatorId">
                <option value="">Escolha um validador...</option>
                <option v-for="(validator, vi) in elem.available_validators || []" :value="validator.validator_id" :key="vi">
                  {{ validator.validator_name }}
                </option>
              </base-select>
            </div>

            <div class="text-end col-2 p-0" v-if="!props.validateData.validationToTransfer.value">
              <div class="text-uppercase">Data</div>
              <div>{{ formatDate(elem.validation_date) }}</div>
            </div>

            <div class="text-end col-4 p-0 align-self-end" v-if="props.validateData.validationToTransfer.value">
              <!-- <div class="text-uppercase">Decisão</div> -->
              <button class="ddl-alt-padding w-50" v-if="elem.newValidatorId" @click="props.validateData.ChangeValidator(elem)">TRANSFERIR</button>
            </div>
          </div>

          <div class="row p-1 m-0" v-if="canPostValidation(elem) && !props.validateData.validationToTransfer.value" v-show="elem.showDetail">
            <div class="col-12 p-0">
              <button class="col-12 ddl-alt-padding" v-if="canPostValidation(elem)" @click="props.validateData.Validate(elem)">PUBLICAR</button>
            </div>
          </div>

          <div v-if="elem.showOtherValidators">
            
            <div class="list-items" v-for="(reqValidation, hi) in elem.otherValidators" :key="hi">
              <div class="row align-items-center p-1 m-0">
                <span class="col-5 p-0 span-elem line-clamp line-clamp-1" @mouseenter="Gems.Tooltip($event.target, elem.sitemap, 'tooltip tooltip-left')">
                  {{ reqValidation.designation }}
                </span>
                
                <span class="col-5 p-0 radios">
                  <RatingScale :rating-data="props.ratingData" :element="reqValidation" :mobile-view="true" :validate-skills="true"/>
                </span>

                <div class="col-2 p-0 ps-1 d-flex">
                  <div class="d-flex justify-content-center flex-grow-1">
                    <i class="align-content-center far fa-eye" :class="{'eye-notification': reqValidation.has_files_not_viewed || reqValidation.has_unread_messages_only_validators || reqValidation.has_unread_messages}" 
                      @click="openHistoryItemModal(reqValidation)" @mouseenter="Gems.Tooltip($event.target, 'Detalhes', 'tooltip')" v-show="reqValidation.selectedValidatorId"></i>
                  </div>
                  <i class="bi bi-chevron-down col-auto p-0 ps-1 align-content-center text-end" :class="{'bi-chevron-up': reqValidation.showDetail}" @click="reqValidation.showDetail = !reqValidation.showDetail"></i>
                </div>
              </div>

              <div class="row element-detail p-1 m-0 small" v-show="reqValidation.showDetail">
                <div class="col-4 p-0">
                  <div class="text-uppercase">Validador</div>
                  <base-select class="ddl-alt-padding" v-model="reqValidation.selectedValidatorId" v-if="reqValidation.validators_count > 1">
                    <option value="">Escolha um validador...</option>
                    <option v-for="(validator, vi) in reqValidation.validators" :value="validator.validator_id" :key="vi">{{ validator.validator_name}}</option>
                  </base-select>

                  <span v-else>
                    {{ reqValidation.validators[reqValidation.selectedValidatorId].validator_name }}
                  </span>
                </div>

                <div class="col-6 p-0">
                  <div class="text-uppercase">Decisão</div>
                  <div v-if="reqValidation.selectedValidatorId">{{ VALIDATION_LABEL[reqValidation.validators[reqValidation.selectedValidatorId]?.validation]}}</div>
                </div>

                <div class="text-end col-2 p-0">
                  <div class="text-uppercase">Data</div>
                  <span>{{ reqValidation?.validators[reqValidation?.selectedValidatorId]?.validation_date }}</span>
                </div>
              </div>

              <div class="row p-1 m-0" v-if="canPostValidation(reqValidation.validators[reqValidation.selectedValidatorId])">
                <div class="col-12 p-0">
                  <button class="col-12 ddl-alt-padding" @click="validateHistoryItem(reqValidation)">PUBLICAR</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.row {
  padding: 5px;
}

button {
  padding: var(--default-app-sm-padding) !important;
}

.input-small-padding {
  padding: 7px 10px !important;
}

.element-detail {
  color: var(--default-font-color) !important;
}

.card {
  background-color: #f8f9fa; /* light gray background */
}

.card .text-uppercase {
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

.div-admin-filter,
.div-admin-filter-input {
  display: flex;
  gap: 20px;
}

.div-admin-sort {
  display: flex; 
  gap: 5px;
  align-items: center; 
}

.div-admin-filter {
  font-size: .85em;
  margin-bottom: -5px;
}

.div-radios div {
  gap: 5px; 
}

.radios {
  display: flex;
  font-size: 1.2em;
  justify-content: center;
}

.div-user-sitemap {
  display: flex;
  gap: 5px;
  padding: 10px 0px;
}

.fa-envelope { 
  position: relative;
  left: 0px;
  top: -9px;
  font-size: 0.7em !important;
  width: 0px;
}

/* .ddl-alt-padding {
  padding: 3px !important;
} */

.list-item {
  border: 2px solid transparent;
}

.div-history-frame {
  border: 2px solid;
  margin-bottom: 2px;
}

.icon-size {
  font-size: unset !important;
  position: unset;
  width: auto;
}

@media screen and (max-width: 700px) {
  .list-item {
    font-size: .85em;
  }
}

@media screen and (max-width: 400px) {
  .radios {
    display: grid;
    grid-template-columns: 30px 30px 30px;
    row-gap: 3px;
  }

  .radios input {
    transform: scale(1) !important;
    margin-top: 0px;
  }

  .radios :deep(> .div-rating-frame:nth-child(3)) {
    border-top-right-radius: 25px !important;
    border-bottom-right-radius: 25px !important;
    overflow: hidden !important;
  }

  .radios :deep(> .div-rating-frame:nth-child(4)) {
    border-top-left-radius: 25px !important;
    border-bottom-left-radius: 25px !important;
    overflow: hidden !important;
  }
}
</style>